import Vue from 'vue'
import axios from "axios"
import cookie from 'vue-cookie'
import router from '@/router'
// 创建axios实例
const service = axios.create({
  //   baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  baseURL: 'https://api.artmediaplatform.cn', // api的base_url
  timeout: 50000 // 请求超时时间
});
// service.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可以在这里添加请求头等信息
    // const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    config.headers.Authorization = cookie.get('token') ? 'Bearer ' + cookie.get('token') : ''
    return config;
  },
  error => {
    // 请求错误处理
    console.log(error); // for debug
    Promise.reject(error);
  }
);
// 响应拦截器
// 对响应数据做处理，例如只返回data部分
// 根据返回的状态码做相应处理，例如401未授权等
service.interceptors.response.use(
  response => {
    const res = response.data;
    console.log(res)
    if (res.code == 0) {
       return res;
    }
    if (res.code == 401) {
        Vue.prototype.$message.error('登录过期，请重新登录！')
        cookie.set('token', null, -1)
        cookie.set('uId', null, -1)
        router.push({ path: '/login' }).catch(err => { console.log('err ' + err) })
    }
    // if (res.code == 3003000) {
    //   Vue.prototype.$message.success('请求错误，请联系管理员！')
    //   console.log(res.msg)
    // }
    // if (res.code != 0 && res.code != 401) {
    //   console.log(res.msg)
    //   Vue.prototype.$message.error('请求错误，请联系管理员！')
    // }
    return res;
  },
  error => {
    // 响应错误处理
    console.log('err' + error); // for debug
    return Promise.reject(error);
  }
);
export default service;